import React from 'react';
import Popover from '@mui/material/Popover';
import ModalConfirm from '../../../components/sarang-modals/modal-confirm/modal-confirm';
import dayjs from 'dayjs';

export const ShipperModals = ({
    anchorEl,
    handleClosePopover,
    cuisineData,
    buttonOpenConfirmRef,
    isOpenActiveDialog,
    selectedItem,
    closeConfirmDialog,
    handleConfirm
}) => {
    const open = Boolean(anchorEl);
    return (
        <>
            <Popover
                id='buoc1'
                open={open}
                anchorEl={anchorEl}
                onClose={handleClosePopover}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <div className="mt-2 mb-2 ml-2 mr-2">
                    {(cuisineData && cuisineData.length > 0) ? cuisineData.map((row, index) => (
                        <div key={index}>
                            {index + 1}. {row.orderCode} - SL: <b>{row.quatity}</b> 
                            {row.deliveryType == 0 ? 
                                <> - {row.address} - {row.communeName}, {row.districtName}</> : 
                                <> - Tự lấy</>
                            } 
                        </div>
                    )) : <></>}
                </div>
            </Popover>

            <button ref={buttonOpenConfirmRef} type="button" className="d-none" data-toggle="modal" data-target="#modalConfirm">
                Launch modal confirm
            </button>

            <ModalConfirm
                title={"Xác nhận"}
                prompt={
                    isOpenActiveDialog ? "Ae/Ce có chắc chắn muốn xác nhận đã giao cho Ae Shipper: " +
                        selectedItem?.herdsmanDeliveryName + " " + (selectedItem?.receiptTime === 1 ? "Sáng " : (selectedItem?.receiptTime === 2 ? "Trưa " : "Chiều ")) +
                        dayjs(selectedItem?.deliveryDate).format("DD/MM/YYYY") + " Số lượng: <b>" + selectedItem?.quatity + "</b>" : ""
                }
                open={isOpenActiveDialog}
                onClose={closeConfirmDialog}
                onConfirm={handleConfirm}
            />
        </>
    );
};
